import {
  IField,
  IList,
  IListColumn,
  IListElement,
  IListElementCell,
} from 'app/services/api5-service/api.interface';

import { ISPFormState } from 'common/dynamic-form/model';
import { DocHelper } from 'utils/dochelper';

import { getBaseCell } from './cell-types/get-base-cell';
import { getButtonCellWithData } from './cell-types/get-button-cell-with-data';
import { getControlCellWithData } from './cell-types/get-control-cell-with-data';
import { getDataCellWithData } from './cell-types/get-data-cell-with-data';
import { getImgCellWithData } from './cell-types/get-img-cell-with-data';
import { getLinkCellWithData } from './cell-types/get-link-cell-with-data';
import { getListCellWithData } from './cell-types/get-list-cell-with-data';
import { getMsgCellWithData } from './cell-types/get-msg-cell-with-data';
import { getPriceCellWithData } from './cell-types/get-price-cell-with-data';
import { getSelectCell } from './cell-types/get-select-cell';
import { getStructCellWithData } from './cell-types/get-struct-cell-with-data';

import { IListCellUi } from '../list-cell/model';
import { ListConfig } from '../model';
/**
 * Get list row cell for given list element
 *
 * @param control
 * @param field
 * @param column
 * @param element
 * @param state
 * @param config - list config
 * @param rowId
 */
export function getListCell(
  control: IList,
  field: IField,
  column: IListColumn,
  element: IListElement,
  state: ISPFormState,
  config: ListConfig,
  rowId?: string,
): IListCellUi[] {
  const dataForCell = element[column.$name];
  if (!dataForCell) {
    const baseCell = getBaseCell(element, column, state, dataForCell, rowId);
    // data not required for select cell
    if (baseCell.type === 'select') {
      return [getSelectCell(baseCell)];
    }
    return [baseCell];
  }

  const cellsData =
    DocHelper.getArrayWrapperValue<IListElementCell>(dataForCell);
  return cellsData.map(cellData => {
    const baseCell = getBaseCell(element, column, state, cellData, rowId);

    switch (baseCell.type) {
      case 'img':
        return getImgCellWithData(baseCell, cellData);
      case 'hidden_button':
      case 'button':
        return getButtonCellWithData(baseCell, element, column, state);
      case 'control':
        return getControlCellWithData(baseCell, cellData, state, config);
      case 'msg':
        return getMsgCellWithData(baseCell, state, cellData);
      case 'data':
        return getDataCellWithData(baseCell, cellData);
      case 'price':
        return getPriceCellWithData(
          control,
          field,
          baseCell,
          column,
          state,
          cellData,
        );
      case 'struct':
        return getStructCellWithData(baseCell, column, state, cellData);
      case 'list':
        return getListCellWithData(
          control,
          field,
          baseCell,
          column,
          state,
          cellData,
          config,
        );
      case 'link':
        return getLinkCellWithData(baseCell, state, cellData);
      case 'empty':
      default:
        return baseCell;
    }
  });
}
